import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import FoundNewHome from "@/pages/FoundNewHome";
import Collections from "@/pages/Collections";
import About from "@/pages/About";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import ProductsList from "@/pages/admin/ProductsList";
import ProductEdit from "@/pages/admin/ProductEdit";
import CollectionsList from "@/pages/admin/CollectionsList";
import OrdersList from "@/pages/admin/OrdersList";
import SiteContent from "@/pages/admin/SiteContent";
import SocialMarketing from "@/pages/admin/SocialMarketing";
import Subscribers from "@/pages/admin/Subscribers";
import PagesList from "@/pages/admin/PagesList";
import PageEdit from "@/pages/admin/PageEdit";
import Page from "@/pages/Page";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <CartProvider>
              <ScrollToTop />
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/product/:slug" element={<ProductDetail />} />
                  <Route path="/collections" element={<Collections />} />
                  <Route path="/archive" element={<FoundNewHome />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/page/:slug" element={<Page />} />
                  <Route path="/payment/success" element={<PaymentSuccess />} />
                  <Route path="/payment/cancel" element={<PaymentCancel />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<AdminLayout />}>
                    <Route index element={<Dashboard />} />
                    <Route path="products" element={<ProductsList />} />
                    <Route path="products/new" element={<ProductEdit />} />
                    <Route path="products/:id" element={<ProductEdit />} />
                    <Route path="collections" element={<CollectionsList />} />
                    <Route path="orders" element={<OrdersList />} />
                    <Route path="content" element={<SiteContent />} />
                    <Route path="pages" element={<PagesList />} />
                    <Route path="pages/:id" element={<PageEdit />} />
                    <Route path="social" element={<SocialMarketing />} />
                    <Route path="subscribers" element={<Subscribers />} />
                  </Route>
                </Routes>
              </Layout>
              <CartDrawer />
              <Toaster theme="dark" position="bottom-right" toastOptions={{
                style: { background: "#0F1D15", color: "#F4EBE1", border: "1px solid rgba(197,160,89,0.4)" }
              }} />
            </CartProvider>
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
